var _path, _path2, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 177,
    viewBox: "0 0 177 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8427 69.6139C93.9057 64.0681 98.1739 59.7441 103.653 56.6476C109.132 53.551 115.341 52 122.282 52C130.791 52 138.072 54.2485 144.131 58.7398C150.19 63.2312 154.241 69.3573 156.283 77.1182H137.09C135.661 74.1221 133.636 71.8457 131.014 70.2779C128.392 68.7157 125.412 67.929 122.081 67.929C116.703 67.929 112.345 69.8036 109.015 73.5418C105.678 77.2855 104.01 82.2902 104.01 88.5502C104.01 94.8102 105.678 99.8149 109.015 103.559C112.351 107.302 116.703 109.171 122.081 109.171C125.418 109.171 128.392 108.39 131.014 106.823C133.631 105.26 135.661 102.978 137.09 99.9823H156.283C154.241 107.743 150.19 113.853 144.131 118.31C138.072 122.768 130.791 125 122.282 125C115.341 125 109.126 123.455 103.653 120.352C98.1739 117.256 93.9001 112.949 90.8427 107.436C87.7796 101.924 86.2509 95.6304 86.2509 88.5502C86.2453 81.4756 87.7796 75.1654 90.8427 69.6139Z",
    fill: "url(#paint0_linear_1325_11224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.037 124.627L51.9305 97.2121H47.6902V124.627H30V52H59.6929C65.4144 52 70.2992 53.0007 74.3302 55.0021C78.3669 57.0035 81.3803 59.7455 83.3817 63.2281C85.3831 66.7108 86.3838 70.5892 86.3838 74.869C86.3838 79.6972 85.0212 84.0109 82.2962 87.7988C79.5711 91.5924 75.5514 94.2836 70.2426 95.8666L87 124.627H67.037ZM47.6902 84.695H58.6583C61.8978 84.695 64.3289 83.9035 65.9515 82.3148C67.5684 80.7318 68.3826 78.4873 68.3826 75.5926C68.3826 72.8337 67.5684 70.6627 65.9515 69.074C64.3289 67.491 61.8978 66.6938 58.6583 66.6938H47.6902V84.695Z",
    fill: "url(#paint1_linear_1325_11224)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 88.5,
    r: 86.5,
    stroke: "#E86747",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1325_11224",
    x1: 121.267,
    y1: 52,
    x2: 121.267,
    y2: 125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C1702"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1325_11224",
    x1: 58.5,
    y1: 52,
    x2: 58.5,
    y2: 124.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C1702"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.7a637406edcecf0020bd1b690fac1fb4.svg";
export { ForwardRef as ReactComponent };